define('shared/util/validate/validators/notRegistered',[ 
    'shared/lib/validate',
    'shared/remote/member/has',
    'shared/remote/member/house',
    'shared/page/apiVersion',
    'shared/util/state/adapters/persistent',
    'shared/initializer/form/newHouseAdapters/mixins/MemberCreatable',
    'shared/util/state',
    'Promise'
], function ( 
    validate, 
    hasMember, 
    getMemberHouse, 
    getAPIVersion,
    persistentAdapter,
    MemberCreatable,
    state,
    Promise
) {
    var KEY = 'notRegistered';

    function validator(value, options){
        if(!value){
            return Promise.reject('notRegistered -- validator : email value not set.');
        }

        return Promise.all([
            getAPIVersion(), 
            getMemberHouse({
                email: value
            })
        ])
            .then(function(values){
                var apiVersion = values[0];
                var memberHouse = values[1];
                if (apiVersion === 'new-house') {
                    // ideally new house should be retired after releasing this change 
                    // so there will be no more new house registration and this clause 
                    // should never be hit on production unless for testing purpose
                    // but it is still nice to get it cover here as author might 
                    // accidently enable new house switch, and sometime we might still
                    // want to register new house user for testing purpose
                    return state.adapters.add(persistentAdapter)
                        .then(function(){
                            return state.get(MemberCreatable.STATE_KEY_ENABLE_NEW_HOUSE);
                        })
                        .then(function(values) {
                            var isNewHouseEnabled = values && 
                                values[0] && 
                                values[0].value === true;
                            if (isNewHouseEnabled) {
                                switch (memberHouse) {
                                    case getMemberHouse.NOT_EXIST:
                                        return false;
                                    default:
                                        return true;
                                }
                            }

                            return true;
                        });
                } else {
                    switch (memberHouse) {
                        case getMemberHouse.NOT_EXIST:
                        case getMemberHouse.RE_REGISTER:
                            return false;
                        default:
                            return true;
                    }
                }
            })
            .then(function(hasThatMember){
                return new Promise(function(resolve, reject){
                    if (hasThatMember) {
                        reject(options.message || 'Email address was registered with us.');
                    }
                    else {
                        resolve();
                    }
                });
            }, function(){
                return new Promise(function(resolve, reject){
                    reject( options.message || 'Network error.');
                });
            });
    }

    // register to validate js
    validate.validators[KEY] = validator;
    validator.KEY = KEY;

    return validator;

});
